/* cjl-cart.js — carrito (build carrito · medidas-build). Vanilla, sin GSAP.
   El drawer nativo de Eurus no tiene hook: se pinta perezosamente en #x-cart-drawer-container y en cada cambio
   de carrito Eurus reemplaza #CartDrawer.innerHTML entero. Aquí: (1) MutationObserver sobre el contenedor;
   (2) cuando hay un #update-cart sin vestir, se pide sections/cjl-cart-drawer.liquid por la Section Rendering API
   (`?section_id=cjl-cart-drawer`) y se colocan sus slots (progreso por cantidad, cross-sell, fila applied, línea
   de confianza, "Have a coupon?", label del checkout, estado vacío) y se visten las filas nativas (campo de familia,
   título sin sufijo, meta oz/ml·familia, "Remove" en texto); (3) Add del cross-sell → cart/add.js →
   eurus:cart:reload (Eurus re-pinta, se vuelve a vestir); (4) celebración 2+: el segundo segmento se llena una
   sola vez en ≤200 ms; con prefers-reduced-motion no hay transición (CSS). La lógica de carrito sigue siendo de Eurus. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var lastCount = null;
  var pending = false;
  var raf = 0;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function q(sel, ctx) { return (ctx || document).querySelector(sel); }

  function dress(drawer, html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var data = doc.querySelector('.cjl-cart-data');
    if (!data) return;
    var count = parseInt(data.getAttribute('data-cjl-count'), 10) || 0;
    var slot = function (name) { return data.querySelector('[data-cjl-slot="' + name + '"]'); };
    var heading = q('.x-cart-heading', drawer);
    var body = heading && heading.nextElementSibling;
    drawer.setAttribute('data-cjl-dressed', '1');
    drawer.classList.toggle('is-empty', count === 0);

    if (count === 0) {
      var e = slot('empty');
      if (e && body) body.insertAdjacentElement('afterbegin', e);
      lastCount = 0;
      return;
    }

    var c = slot('count');
    var badge = q('.x-cart-item-count', drawer);
    if (c && badge) badge.textContent = c.textContent;

    var p = slot('progress');
    if (p && heading) heading.insertAdjacentElement('afterend', p);

    var x = slot('crosssell');
    var form = q('#CartDrawer-Form', drawer);
    if (x && form) form.insertAdjacentElement('afterend', x);

    var totals = q('.cart-drawer-price-total', drawer);
    if (totals) {
      var ft = slot('footer-top');
      if (ft) totals.insertAdjacentElement('afterbegin', ft);
      var fn = slot('footer-note');
      if (fn) totals.appendChild(fn);
      var label = totals.querySelector('p.h4');
      if (label) label.textContent = 'Subtotal';
      var tp = totals.querySelector('#total-price');
      var tv = slot('total');
      if (tp && tv) tp.textContent = tv.textContent;
    }
    var co = q('#checkout-submit', drawer);
    var cl = slot('checkout');
    if (co && cl) {
      var s = co.querySelector('span');
      (s || co).textContent = cl.textContent;
      var fb = slot('footer-bottom');
      var wrap = co.parentElement;
      if (fb && wrap) wrap.insertAdjacentElement('afterend', fb);
    }

    var items = data.querySelectorAll('[data-cjl-item]');
    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var input = document.getElementById('cart-qty-' + it.getAttribute('data-cjl-item'));
      var row = input && input.closest('tr.cart-item');
      if (!row) continue;
      row.style.setProperty('--cjl-fam', 'var(--cjl-field-' + it.getAttribute('data-fam') + ')');
      var a = row.querySelector('.product-info-column-1 a');
      if (a && !row.querySelector('.cjl-cart__meta')) {
        a.textContent = it.getAttribute('data-title');
        var m = document.createElement('span');
        m.className = 'cjl-cart__meta';
        m.textContent = it.getAttribute('data-meta');
        a.parentElement.insertAdjacentElement('afterend', m);
      }
      var rm = row.querySelector('button[id^="remove-"]');
      if (rm) { rm.textContent = 'Remove'; rm.setAttribute('aria-label', 'Remove'); }
    }

    if (p && lastCount !== null && lastCount < 2 && count >= 2 && !reduce) {
      var seg = p.querySelectorAll('.cjl-cart__seg')[1];
      if (seg) {
        seg.classList.remove('is-filled');
        requestAnimationFrame(function () { requestAnimationFrame(function () { seg.classList.add('is-filled'); }); });
      }
    }
    lastCount = count;
  }

  function refresh() {
    if (pending) return;
    var drawer = q('#update-cart');
    if (!drawer || drawer.hasAttribute('data-cjl-dressed')) return;
    pending = true;
    fetch(window.location.pathname + '?section_id=cjl-cart-drawer', { headers: { Accept: 'text/html' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        pending = false;
        if (q('#update-cart') !== drawer) { schedule(); return; } /* Eurus re-pintó mientras tanto: repetir */
        if (html) dress(drawer, html);
      })
      .catch(function () { pending = false; });
  }

  function schedule() {
    if (raf) return;
    raf = requestAnimationFrame(function () { raf = 0; refresh(); });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var add = t.closest('[data-cjl-add]');
    if (add && !add.disabled) {
      add.disabled = true;
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(add.getAttribute('data-cjl-add'), 10), quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () { document.dispatchEvent(new CustomEvent('eurus:cart:reload')); })
        .catch(function () { add.disabled = false; });
      return;
    }
    var xs = t.closest('[data-cjl-xs]');
    if (xs) {
      var track = xs.closest('.cjl-cart__xsell').querySelector('[data-cjl-xs-track]');
      var card = track && track.firstElementChild;
      if (card) {
        var step = card.getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
        track.scrollBy({ left: step * parseInt(xs.getAttribute('data-cjl-xs'), 10), behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
      }
      return;
    }
    var code = t.closest('[data-cjl-code]');
    if (code && window.Alpine && window.Alpine.store('xCartHelper')) {
      var h = window.Alpine.store('xCartHelper');
      h.openField = h.openField === 'discount_field' ? false : 'discount_field';
    }
  });

  /* flechas del deslizador: apagadas en los extremos (el drawer se re-pinta: delegación en captura) */
  document.addEventListener('scroll', function (e) {
    var track = e.target;
    if (!track.matches || !track.matches('[data-cjl-xs-track]')) return;
    var sec = track.closest('.cjl-cart__xsell');
    var prev = sec.querySelector('[data-cjl-xs="-1"]'), next = sec.querySelector('[data-cjl-xs="1"]');
    if (prev) prev.disabled = track.scrollLeft <= 2;
    if (next) next.disabled = track.scrollLeft >= track.scrollWidth - track.clientWidth - 2;
  }, true);

  function boot() {
    var container = q('#x-cart-drawer-container');
    if (!container || container.dataset.cjlInit) return;
    container.dataset.cjlInit = '1';
    new MutationObserver(schedule).observe(container, { childList: true, subtree: true });
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
